export default "__VITE_ASSET__CUhKWJxF__"